import { render, staticRenderFns } from "./LoggedOutFooter.vue?vue&type=template&id=3dfc4874&scoped=true"
import script from "./LoggedOutFooter.vue?vue&type=script&lang=js"
export * from "./LoggedOutFooter.vue?vue&type=script&lang=js"
import style0 from "./LoggedOutFooter.vue?vue&type=style&index=0&id=3dfc4874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfc4874",
  null
  
)

export default component.exports